import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { findLink } from '../../../../../../../LinkyLinky';
import LearningCollectionEditStore from '../../../Store';
import { CustomizeState } from '../../../Store/Types';
import ChooseProductLicenseState from './ChooseProductLicenseState';

interface Props {
  store: LearningCollectionEditStore;
  state: CustomizeState;
}

function ProductLicense({ store, state }: Props) {
  return findLink('product-licenses', state.learningCollectionEditFormResource.links)
    .map(() => <ChooseProductLicenseState store={store} state={state} />)
    .getOrElse(emptyFragment);
}

export default observer(ProductLicense);
